import { render, staticRenderFns } from "./o4results.vue?vue&type=template&id=30a6bcc9&scoped=true"
import script from "./o4results.vue?vue&type=script&lang=js"
export * from "./o4results.vue?vue&type=script&lang=js"
import style0 from "./o4results.vue?vue&type=style&index=0&id=30a6bcc9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6bcc9",
  null
  
)

export default component.exports